export const GOALS_TEXT_SCOPE_STYLES = `
  .goals-text-scope,
  .goals-text-scope div,
  .goals-text-scope p,
  .goals-text-scope span,
  .goals-text-scope label,
  .goals-text-scope small,
  .goals-text-scope strong,
  .goals-text-scope td,
  .goals-text-scope th,
  .goals-text-scope li,
  .goals-text-scope a,
  .goals-text-scope input,
  .goals-text-scope textarea,
  .goals-text-scope select,
  .goals-text-scope option,
  .goals-text-scope pre {
    color: #000 !important;
  }

  .goals-text-scope input::placeholder,
  .goals-text-scope textarea::placeholder {
    color: #000 !important;
    opacity: 1;
  }

  .goals-text-scope .recharts-text,
  .goals-text-scope .recharts-label,
  .goals-text-scope .recharts-cartesian-axis-tick-value,
  .goals-text-scope .recharts-legend-item-text,
  .goals-text-scope svg text {
    fill: #000 !important;
    color: #000 !important;
  }
`;

export const GOAL_STATUS_COLORS = {
  COMPLETED: { bg: '#dcfce7', text: '#166534', border: '#86efac' },
  ON_TRACK: { bg: '#dbeafe', text: '#1d4ed8', border: '#93c5fd' },
  AT_RISK: { bg: '#ffedd5', text: '#c2410c', border: '#fdba74' },
  OVERDUE: { bg: '#fee2e2', text: '#b91c1c', border: '#fca5a5' },
  CANCELLED: { bg: '#e5e7eb', text: '#4b5563', border: '#d1d5db' },
  ACTIVE: { bg: '#ede9fe', text: '#5b21b6', border: '#c4b5fd' },
  DRAFT: { bg: '#fef3c7', text: '#92400e', border: '#fcd34d' },
};

export const MODULE_OPTIONS = [
  'ALL_MODULES',
  'SALES',
  'PRODUCTION',
  'QC',
  'HR',
  'INVENTORY',
  'ACCOUNTS',
  'ADMIN',
];

export const MODULE_META = {
  PRODUCTION: { icon: '🏭', color: '#3b82f6', accent: '#dbeafe', border: '#93c5fd', description: 'Output, stages, complexity, and machine requirements.' },
  QC: { icon: '✅', color: '#10b981', accent: '#dcfce7', border: '#86efac', description: 'Defects, inspections, rework, and quality thresholds.' },
  SALES: { icon: '📈', color: '#8b5cf6', accent: '#ede9fe', border: '#c4b5fd', description: 'Revenue, conversion, customers, and category targets.' },
  HR: { icon: '👥', color: '#f59e0b', accent: '#fef3c7', border: '#fcd34d', description: 'Hiring, training, attendance, and retention goals.' },
  INVENTORY: { icon: '📦', color: '#14b8a6', accent: '#ccfbf1', border: '#5eead4', description: 'Stock health, suppliers, wastage, and reorder controls.' },
  ACCOUNTS: { icon: '💰', color: '#ef4444', accent: '#fee2e2', border: '#fca5a5', description: 'Collections, compliance, cost reduction, and reporting speed.' },
  ADMIN: { icon: '⚙️', color: '#64748b', accent: '#e2e8f0', border: '#cbd5e1', description: 'Automation, uptime, compliance, and operational governance.' },
  ALL_MODULES: { icon: '🌐', color: '#0f766e', accent: '#ccfbf1', border: '#99f6e4', description: 'Company-wide goals visible to every module.' },
};

export const MODULE_FIELD_CONFIGS = {
  PRODUCTION: [
    { name: 'target_pieces', label: 'Target Pieces', type: 'number', required: true, min: 1, helpText: 'Production quantity target for this goal.' },
    { name: 'stage_codes', label: 'Stages Involved', type: 'multi-select', options: ['WAX_CREATION', 'CASTING', 'POLISHING', 'FILING', 'BUFFING', 'ASSEMBLING', 'HAND_SETTING', 'TREE_MAKING', 'TREE_CUTTING', 'WAX_CLEANING', 'WAX_SETTING'], helpText: 'Select every production stage included.' },
    { name: 'quality_threshold_percentage', label: 'Quality Threshold %', type: 'number', min: 0, max: 100, step: 0.01, helpText: 'Minimum acceptable QC pass rate.' },
    { name: 'metal_type', label: 'Metal Type', type: 'select', options: ['GOLD', 'SILVER', 'PLATINUM', 'MIXED'] },
    { name: 'design_complexity', label: 'Design Complexity', type: 'select', options: ['SIMPLE', 'MODERATE', 'COMPLEX'] },
    { name: 'machine_required', label: 'Machine Required', type: 'boolean', checkboxLabel: 'This goal needs specific equipment or machine capacity.' },
  ],
  QC: [
    { name: 'defect_reduction_target_percentage', label: 'Defect Reduction Target %', type: 'number', required: true, min: 0, max: 100, step: 0.01, helpText: 'Set the defect-rate improvement target.' },
    { name: 'inspection_stages', label: 'Inspection Stages', type: 'multi-select', options: ['WAX_CREATION', 'CASTING', 'POLISHING', 'FILING', 'BUFFING', 'ASSEMBLING', 'HAND_SETTING'] },
    { name: 'critical_defect_types', label: 'Critical Defect Types', type: 'multi-select', options: ['WEIGHT_VARIANCE', 'STONE_SETTING', 'FINISH_QUALITY', 'STRUCTURAL', 'MEASUREMENT'] },
    { name: 'sampling_percentage', label: 'Sampling Percentage', type: 'number', min: 0, max: 100, step: 0.1, helpText: 'Industry benchmark is usually 10-20%.' },
    { name: 'rework_time_limit_hours', label: 'Rework Time Limit (Hours)', type: 'number', min: 1 },
  ],
  SALES: [
    { name: 'revenue_target_amount', label: 'Revenue Target (INR)', type: 'number', required: true, min: 0, step: 0.01 },
    { name: 'customer_segment', label: 'Customer Segment', type: 'select', options: ['RETAIL', 'WHOLESALE', 'CORPORATE', 'EXPORT'] },
    { name: 'product_categories', label: 'Product Categories', type: 'multi-select', options: ['RINGS', 'NECKLACES', 'BRACELETS', 'EARRINGS', 'PENDANTS', 'ANKLETS'] },
    { name: 'discount_cap_percentage', label: 'Discount Cap %', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'conversion_rate_target', label: 'Conversion Rate Target %', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'new_customer_count_target', label: 'New Customer Count Target', type: 'number', min: 0 },
  ],
  HR: [
    { name: 'hiring_target_count', label: 'Hiring Target Count', type: 'number', min: 0 },
    { name: 'department', label: 'Department', type: 'select', options: ['PRODUCTION', 'QC', 'SALES', 'HR', 'ADMIN', 'ACCOUNTS', 'INVENTORY'] },
    { name: 'training_hours_target', label: 'Training Hours Target', type: 'number', min: 0 },
    { name: 'attendance_target_percentage', label: 'Attendance Target %', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'retention_target_percentage', label: 'Retention Target %', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'skill_development_areas', label: 'Skill Development Areas', type: 'text', helpText: 'Describe the main upskilling focus areas.' },
  ],
  INVENTORY: [
    { name: 'stock_turnover_target', label: 'Stock Turnover Target', type: 'number', min: 0, step: 0.1 },
    { name: 'material_categories', label: 'Material Categories', type: 'multi-select', options: ['RAW_METAL', 'STONES', 'CONSUMABLES', 'PACKAGING', 'TOOLS'] },
    { name: 'stockout_reduction_percentage', label: 'Stockout Reduction %', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'reorder_point_optimization', label: 'Reorder Point Optimization', type: 'boolean', checkboxLabel: 'This goal includes reorder-point optimization.' },
    { name: 'wastage_reduction_target_percentage', label: 'Wastage Reduction Target %', type: 'number', min: 0, max: 100, step: 0.01 },
    { name: 'supplier_count_target', label: 'Supplier Count Target', type: 'number', min: 0 },
  ],
  ACCOUNTS: [
    { name: 'receivables_collection_target_percentage', label: 'AR Collection Target %', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'payment_terms_days', label: 'Payment Terms (Days)', type: 'number', min: 0 },
    { name: 'cost_reduction_target_amount', label: 'Cost Reduction Target (INR)', type: 'number', min: 0, step: 0.01 },
    { name: 'gst_compliance_score', label: 'GST Compliance Score', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'bad_debt_reduction_percentage', label: 'Bad Debt Reduction %', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'financial_report_turnaround_days', label: 'Report Turnaround (Days)', type: 'number', min: 1 },
  ],
  ADMIN: [
    { name: 'system_uptime_percentage', label: 'System Uptime %', type: 'number', min: 0, max: 100, step: 0.01 },
    { name: 'process_automation_count', label: 'Process Automation Count', type: 'number', min: 0 },
    { name: 'user_training_completion_percentage', label: 'User Training Completion %', type: 'number', min: 0, max: 100, step: 0.1 },
    { name: 'compliance_checklist_items', label: 'Compliance Checklist Items', type: 'number', min: 0 },
    { name: 'vendor_management_score', label: 'Vendor Management Score', type: 'number', min: 0, max: 100, step: 0.1 },
  ],
  ALL_MODULES: [],
};

export const GOAL_TYPE_OPTIONS = [
  'REVENUE',
  'PRODUCTION_QUOTA',
  'QUALITY_METRIC',
  'COST_REDUCTION',
  'DELIVERY_TIME',
  'CUSTOMER_SATISFACTION',
  'INVENTORY_TURNOVER',
  'CUSTOM',
];

export const REVIEW_FREQUENCY_OPTIONS = ['WEEKLY', 'MONTHLY', 'QUARTERLY'];

export const TASK_STATUS_OPTIONS = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'BLOCKED'];

export const prettyLabel = (value) =>
  String(value || '')
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatNumber = (value) =>
  Number(value || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });

export const statusStyle = (status) => GOAL_STATUS_COLORS[String(status || '').toUpperCase()] || GOAL_STATUS_COLORS.ACTIVE;

export const getModuleMeta = (moduleName) => MODULE_META[String(moduleName || '').toUpperCase()] || MODULE_META.ALL_MODULES;

export const getModuleFieldConfigs = (moduleName) => MODULE_FIELD_CONFIGS[String(moduleName || '').toUpperCase()] || [];

export const formatModuleFieldValue = (fieldConfig, value) => {
  if (value == null || value === '' || (Array.isArray(value) && !value.length)) return '-';
  if (fieldConfig?.type === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) return value.map(prettyLabel).join(', ');
  if (typeof value === 'number') return formatNumber(value);
  return prettyLabel(value);
};

export const getVisibleModuleMetrics = (goal, limit = 4) => {
  const config = getModuleFieldConfigs(goal?.assigned_module);
  const values = goal?.module_fields_config || {};
  return config
    .filter((field) => {
      const value = values[field.name];
      if (field.type === 'boolean') return typeof value === 'boolean';
      if (Array.isArray(value)) return value.length > 0;
      return value != null && value !== '';
    })
    .slice(0, limit)
    .map((field) => ({
      key: field.name,
      label: field.label,
      value: formatModuleFieldValue(field, values[field.name]),
    }));
};

export const normalizeEvidencePairs = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return [];
  return Object.entries(value).map(([key, raw]) => ({
    key,
    value: raw == null ? '' : String(raw),
  }));
};

export const evidencePairsToObject = (pairs) => {
  const result = {};
  (pairs || []).forEach(({ key, value }) => {
    const cleanKey = String(key || '').trim();
    const cleanValue = String(value ?? '').trim();
    if (!cleanKey || !cleanValue) return;
    const numericValue = Number(cleanValue);
    result[cleanKey] = Number.isFinite(numericValue) && cleanValue !== '' ? numericValue : cleanValue;
  });
  return result;
};

export const isEmptyObject = (value) =>
  !value || typeof value !== 'object' || Array.isArray(value) ? true : Object.keys(value).length === 0;
